<template>
	<div class="step_container">
		<el-form ref="form" :model="thirdStepForm" :rules="rules" :inline="inline" :label-width="labelWidth" :label-position="labelPosition" size="mini">
      <el-form-item label="任务单价" prop="price">
        <el-input class="number_input" show-word-limit :maxlength="6" v-model="thirdStepForm.price" @input="changePrice" clearable></el-input>
        <p>指导价:<span class="guide_price">{{guidePrice}}元</span><span v-show="showPriceTip == true" class="price_tip">（ {{priceTip}} ）</span></p>
      </el-form-item>
		  <el-form-item label="任务名额" prop="amount">
        <el-input class="number_input" show-word-limit maxlength="4" v-model="thirdStepForm.amount" clearable placeholder="请输入数量" @input="changeNumber"></el-input>
        <p>最低10个名额，发布后可补充名额</span></p>
		  </el-form-item>
      <el-form-item label="预付款">
        <div class="advance_text">{{thirdStepForm.prepayments}} <span>元</span></div>
      </el-form-item>
      <el-form-item label="结算说明" prop="settlement_info">
        <el-input type="textarea" show-word-limit maxlength="200" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入结算说明" v-model="thirdStepForm.settlement_info"/>
      </el-form-item>
      <el-form-item label="联系人" prop="contract_type">
        <el-radio-group v-model="thirdStepForm.contract_type" @change="changeContacts">
          <el-radio :label="item.id" v-for="(item,index) in typeList.contactsList" :key="index">{{item.label}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="contract">
        <el-input class="number_input" maxlength="50" v-model="thirdStepForm.contract" clearable placeholder="请输入联系方式"></el-input>
      </el-form-item>
      <collapse :setText="'更多设置'">
      	<div slot="show">
          
        </div>
        <div slot="hide">
          <el-form-item label="投放范围">
            <el-cascader
              ref="cascaderAddr"
              v-model="thirdStepForm.cityArr"
              :options="typeList.cityList"
              :props="Props"
              @change="handleChange"></el-cascader>
          </el-form-item>
          <el-form-item label="投放时长">
            <div>
              <el-radio-group v-model="thirdStepForm.online_type" size="mini" @change="changeLaunch">
                <el-radio v-for="(item,index) in typeList.launchList" :label="item.id" :key="index" border>{{item.id == 1 ? '长期投放' : '定期投放'}}</el-radio>
              </el-radio-group>
            </div>
            <div v-if="showTime">
              <el-date-picker
                class="mar_t_b"
                v-model="thirdStepForm.date"
                align="right" type="daterange"
                placeholder="选择日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                unlink-panels
                @change="clearQuick"
              >
              </el-date-picker>
              <div>
                <el-radio-group v-model="timeTypes" @change="changeDate" size="small">
                  <el-radio-button :label="1">一周</el-radio-button>
                  <el-radio-button :label="2">两周</el-radio-button>
                  <el-radio-button :label="3">一个月</el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="设备限制">
            <el-radio-group v-model="thirdStepForm.device_limit" @change="changeContacts">
              <el-radio :label="item.id" v-for="(item,index) in typeList.deviceLimit" :key="index">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </collapse>
      <el-form-item>
        <el-checkbox v-model="thirdStepForm.agreed">我已同意</el-checkbox><span class="agreement" @click="watchAgrred">《罗科仕兼职任务电子协议合同》</span>
        <el-popover
          placement="right"
          width="400"
          trigger="click">
          <p class="explain_p">【用户提交时限】</p>
          <p class="explain_p text_indet">用户领取后需在2小时内提交任务审核，超时未提交，名额将自动收回</p>
          <p class="explain_p">【任务单审核时限】</p>
          <p class="explain_p text_indet">请在用户提交任务单审核后24小时天内处理审核，超时未审核，将自动视为审核通过。若因客观原因无法在24小时内完成审核，任务发布后请和工作人员确认具体审核时限</p>
          <span slot="reference" class="more_explain">更多说明</span>
        </el-popover>
      </el-form-item>
		  <el-form-item size="large">
        <slot name="handle"></slot>
		    <!-- <el-button type="primary" @click="firstSubmit">立即创建</el-button>
		    <el-button>取消</el-button> -->
		  </el-form-item>
		</el-form>
    <el-dialog
      title="发布任务电子协议"
      :visible.sync="agreeMent"
      width="500px"
      center>
      <div class="agreement_box">
        <p>欢迎光临哥伦布灵活用工商户平台，为使用哥伦布灵活用工商户平台的服务，您应当阅读并遵守《赚钱任务发布协议》（简称“本协议”）。本协议是您与哥伦布灵活用工商户平台之间的法律协议，是您在哥伦布灵活用工商户平台上发布赚钱任务和/或使用哥伦布灵活用工商户平台服务时使用的通用条款。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款。您不应当以平台未对本协议以合理方式提醒注意或未根据您要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。除非您已阅读并接受本协议所有条款，否则您无权发布任务和/或使用哥伦布灵活用工商户平台提供的服务。您发布任务和/或使用哥伦布灵活用工商户平台的服务即视为您已阅读并同意本协议的约束，并完全服从于哥伦布灵活用工商户平台的统一管理。</p>
        <h6>一、定义</h6>
        <p>1.哥伦布灵活用工商户平台，是指罗科仕科技（北京）股份有限公司开发的移动应用软件（APP）、网站、微信端程序等。</p>
        <p>2.商户，包含注册商户和非注册商户，以下亦称为“您”。注册商户是指通过网站、微信端、移动应用软件（APP）完成全部注册程序后，使用哥伦布灵活用工商户平台服务的商户。非注册商户是指未进行注册，直接登录网站、微信端、移动应用软件（APP）使用哥伦布灵活用工商户平台服务的商户。</p>
        <p>3.协议方，本协议中协议双方合称协议方。罗科仕科技（北京）股份有限公司以及哥伦布灵活用工商户平台在协议中统称为“哥伦布灵活用工商户平台”。</p>
        <p>4.赚钱任务：指的是哥伦布灵活用工商户平台申请发布的信息推广项目。</p>
        <h6>二、协议的效力</h6>
        <p>1.在您按照注册页面提示填写信息、阅读并同意本协议并完成全部注册程序后或以其他哥伦布产品允许的方式实际使用哥伦布灵活用工商户平台服务时，您即受本协议的约束。届时您不应以未阅读本协议的内容或者未获得哥伦布灵活用工商户平台对您问询的解答等理由，主张本协议无效，或要求撤销本协议。</p>
        <p>2.本协议内容包括协议正文及所有哥伦布灵活用工商户平台已经发布或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。您承诺接受并遵守本协议的约定。如果您不同意本协议的约定， 您应立即停止使用哥伦布灵活用工商户平台服务。</p>
        <p>3.哥伦布灵活用工商户平台有权根据国家法律法规的更新、产品和服务规则的调整，不时地制订、修改本协议及各类规则。如您继续使用平台服务的，即表示您接受经修订的协议和规则。如发生有关争议时，以平台发布的最新相关协议和规则为准。</p>
        <h6>三、费用支付</h6>
        <p>1.您应当将相关费用通过哥伦布灵活用工商户平台充值至相关的页面，哥伦布灵活用工商户平台将利用自身的技术力量来保证您费用的安全，您不得将该费用支付给任何工作人员的私人帐户，否则哥伦布灵活用工商户平台将视为未收到款项。</p>
        <p>2.若您充值的金额已经消耗完成，您需要继续使用我们的服务，您需要重新接受本协议，以完成相应的充值手续。</p>
        <p>4.若您完成充值后，由于您的项目未通过平台审核，您可以选择联系平台客服申请退回费用。</p>
        <p>5.哥伦布灵活用工商户平台将努力为您达到约定的服务数量，由于特殊的原因导致哥伦布灵活用工商户平台预计无法达到服务数量，您可以选择进行相应变更或者在项目上线之日起90天后联系客服申请退回未完成的费用。如您申请退费，费用将在完成退费流程后的5个工作日内退回至您帐户。</p>
        <h6>四、平台使用规范</h6>
        <p>1.您在平台发布的信息须是真实、合法和有效的，不得含有任何虚假、夸大的信息。</p>
        <p>2.您了解并确认，平台作为网络信息服务中介平台，仅承担基础的审查义务，对于您发布的信息或内容违反法律法规、本协议约定的或平台认为不适合发布的信息，有权暂停发布、删除或屏蔽等限制措施，但以上审查行为并不视为平台对所发布的信息承担任何连带责任，且通过平台审核后发布的信息，并不代表平台对所发布信息的真实性、合法性、有效性的确认与认同。如您发布的信息侵犯任何第三方的合法权益，您应独立承担由此产生的法律责任。</p>
        <p>3.若平台用户报名您发布的任务，在平台用户成功完成任务后，您可能将会收取该用户的信息包括：姓名、联系方式（手机号码）、相册、示例文本、图片素材等个人档案在内的个人信息。但您没有权利泄露该用户的任何个人信息和使用该用户个人信息进行不法或不道德的获利行为。您应当采取必要措施保护个人信息，避免个人信息被非法访问、转让、披露、变更、破坏，否则由此产生的一切责任由您承担。</p>
        <p>4.您发布的任务不得含有收费项目，不得存在收费行为（包括但不限于直接或间接诱导、要求平台用户进行汇款、转帐等行为），不得向报名您发布的任务的平台用户以任何名义收取任何费用。
5.通过哥伦布灵活用工商户平台，您可以按照哥伦布灵活用工商户平台的规则发布各种信息。但所发布之信息不得含有如下内容：</p>
        <div class="text_indet">
          <p>（1）反对宪法所确定的基本原则，煽动抗拒、破坏宪法和法律、行政法规实施的；</p>
          <p>（2）煽动危害国家安全、泄露国家秘密、颠覆国家政权，推翻社会主义制度的；</p>
          <p>（3）煽动分裂国家、破坏国家统一、损害国家荣誉和民族利益的；</p>
          <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
          <p>（5）捏造或者歪曲事实，散布谣言，扰乱社会秩序的；</p>
          <p>（6）进行政治宣传或破坏国家宗教政策、宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；</p>
          <p>（7）公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；</p>
          <p>（8）损害国家机关信誉的；</p>
          <p>（9）其他违反宪法和法律法规的；</p>
        </div>
        <p>6.在接受平台服务的过程中，您不得从事下列行为：</p>
        <div class="text_indet">
          <p>（1）发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容，包含病毒、木马等可能对平台造成伤害或影响其稳定性的内容制造虚假身份以误导、欺骗他人；</p>
          <p>（2）传送或散布以其他方式实现传送的含有受到知识产权法律保护的图像、相片、软件或其他资料的文件，包括但不限于：版权或商标法（或隐私权或公开权），除非您拥有或控制着相应的权利或已得到所有必要的认可；</p>
          <p>（3）违背平台公布的活动规则，包括但不限于发布虚假信息、欺诈信息等。</p>
        </div>
        <p>7.您了解并同意，平台有权应政府部门（包括司法及行政部门）的要求，向其提供您在平台填写的注册信息和发布纪录等必要信息，且无须征得您的同意或提前通知于您。</p>
        <p>8.在平台上使用服务过程中，您承诺遵守以下约定：</p>
        <div class="text_indet">
          <p>1）在使用平台服务过程中实施的所有行为均遵守国家法律、法规等规范文件及平台各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。您如果违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担所有的法律责任，并确保平台免于因此产生任何损失或增加费用。</p>
          <p>（2）不发布国家禁止发布的信息（除非取得合法且足够的许可），不发布涉嫌侵犯他人知识产权或其它合法权益的信息，不发布违背社会公共利益或公共道德、公序良俗的信息，不发布其它涉嫌违法或违反本协议及各类规则的信息。</p>
          <p>（3）不对平台上的任何数据作商业性利用，包括但不限于在未经平台事先书面同意的情况下，以复制、传播等任何方式使用平台站上展示的资料。</p>
          <p>（4）不使用任何装置、软件或例行程序干预或试图干预平台的正常运作或正在平台上进行的任何活动。</p>
        </div>
        <p>9.您了解并同意：</p>
        <div class="text_indet">
          <p>（1）您违反上述承诺时，平台有权依据本协议的约定，做出相应处理或终止向您提供服务，对于您在平台缴存的保证金或充值的金额，平台有权先行赔付，且无须征得您的同意或提前通知于您，您应承担由此产生一切法律责任及损失。您应配合平台处理相关事项，否则由此产生的一切不利责任由您自行承担。</p>
          <p>（2）根据相关法令的指定或者平台服务规则的判断，您的行为涉嫌违反法律法规的规定或违反本协议和/或规则的条款的，平台有权采取相应措施，包括但不限于直接屏蔽、删除侵权信息、或直接停止提供服务。如因此使平台遭受损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿平台由此产生的损失及发生的费用，包括合理的律师费用。</p>
          <p>（3）对于您在平台上实施的行为，包括您未在平台上实施但已经对平台及平台用户产生影响的行为，平台有权单方认定您行为的性质及是否构成对本协议或平台发布的规则的违反，并据此采取相应的处理措施。您应自行保存与您行为有关的全部证据，并应对无法提供充要证据承担不利后果。</p>
          <p>（4）对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保平台免于承担因此产生的损失或增加的费用。</p>
        </div>
        <h6>五、责任范围和责任限制</h6>
        <p>1.平台与其他的在线使用的互联网网站一样，也会受到各种不良信息、网络安全和网络故障问题的困扰，包括但不限于：</p>
        <div class="text_indet">
          <p>（1）其他商户/平台用户可能会发布一些侵犯您或者其他第三方知识产权、肖像权、姓名权、名誉权、隐私权或其他合法权益的图片、照片、文字等资料；</p>
          <p>（2）面临着诸如黑客攻击、计算机病毒困扰、系统崩溃、网络掉线、网速缓慢、程序漏洞等问题的困扰和威胁。 您充分了解并同意：上述的各种不良信息、网络安全和网络故障问题，并不是平台所导致的问题，由此可能会给您造成其他的损失，概由您自行承担，平台无须向您承担任何责任。</p>
        </div>
        <p>2.您同意，在发现本网站任何内容不符合法律规定，或不符合本协议规定的，您有义务及时通知平台。如果您发现您的个人信息被盗用、您的版权或者其他权利被侵害，请将此情况告知平台并同时提供如下信息和材料：</p>
        <div class="text_indet">
          <p>（1）您是所述的版权或者其他权利的合法拥有者的权利证明；</p>
          <p>（2）您的身份证复印件、营业执照等其他相关资料。 经审查得到证实的，我们将及时删除相关信息。我们仅接受邮寄、电子邮件或传真方式的书面侵权通知。情况紧急的，您可以通过客服电话先行告知，我们会视情况采取相应措施。</p>
        </div>
        <p>3.您了解并同意，平台不对因下述任一情况而导致您的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿：</p>
        <div class="text_indet">
          <p>（1）使用或未能使用平台服务；</p>
          <p>（2）第三方未经批准地使用您的帐户或更改您的数据；</p>
          <p>（3）通过平台服务购买或获取任何商品、样品、数据、信息等行为或替代行为产生的费用及损失；</p>
          <p>（4）您对平台服务的误解；</p>
          <p>（5）任何非因平台的原因而引起的与平台服务有关的其它损失。</p>
        </div>
        <p>4.您同意在使用平台服务过程中显示平台自行或由第三方服务商向您发送的推广或宣传信息（包括商业与非商业信息），其方式和范围可不经向您特别通知而变更。除法律法规明确规定外，您应自行对依该推广信息进行的交易负责，对您因依该推广信息进行的交易或前述第三方服务商提供的内容而遭受的损失或损害，平台不承担任何责任。</p>
        <p>5.平台对下列不可抗力行为免责：信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务。</p>
        <p>6.您应当严格遵守本协议及平台发布的其他协议、活动规则，因您违反协议或规则的行为给第三方或平台造成损失的，您应当承担全部责任。</p>
        <p>7.平台保留在中华人民共和国大陆地区法施行之法律允许的范围内独立决定拒绝服务、关闭商户帐户、清除或编辑内容的权利。</p>
        <h6>六、知识产权条款</h6>
        <p>1.平台为提供本协议服务之目的，有权使用您提供的商标、商号、LOGO或者其他能表明企业来源的标识，您承诺上述信息的合法性、真实性、有效性，并得到相关第三方的合法授权，并保证不会侵犯任何第三方合法权益，如您违反该保证，您应承担由此产生的一切责任。</p>
        <p>2.平台所有内容、设计、图标、图表、文字及其组合、产品、技术、程序等知识产权均归平台所有。未经许可，任何一方不得擅自使用、复制商标、标志、商业信息、技术及其他资料。平台提供服务时所依托软件的著作权、专利权及其他知识产权均归平台所有。任何人不得更改、演绎、拆分、反解平台的技术和程序或以其它任何方式进行可能损害平台专有权利的行为。</p>
        <h6>七、信息安全</h6>
        <p>1.您的帐户均有安全保护功能，请妥善保管您的帐户及密码信息。</p>
        <p>2.平台将通过向其它服务器备份、对商户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。</p>
        <p>3.若发现修改企业信息、企业信息泄露、可以通过官方客服进行相关处理。</p>
        <h6>八、免责条款</h6>
        <p>1.在您成功注册哥伦布灵活用工商户平台帐户后被视为阅读并且同意本协议条款全部内容。</p>
        <p>2.若您不同意本协议内任意内容，请立即停止哥伦布灵活用工商户平台内全部注册信息服务。</p>
        <p>3.若由于您发布的招聘信息不实，导致您自身遭受相关行政机关处罚或给其他商户/平台用户造成损失的，由您自行承担，平台不承担任何责任。</p>
        <h6>九、协议终止</h6>
        <p>1.您有权向平台要求注销您的帐户，经平台审核同意的，平台将注销您的帐户，届时，您与平台基于本协议的合同关系终止。您的帐户被注销后，平台没有义务为您保留或向您披露您帐户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。</p>
        <p>2.您同意，您与平台的协议关系终止后，平台仍享有下列权利：</p>
        <div class="text_indet">
          <p>（1）继续保存您未及时删除的注册信息及您使用平台服务期间发布的所有信息至法律规定的记录保存期满。</p>
          <p>（2）您在使用平台服务期间存在违法行为或违反本协议或规则的行为，平台仍可依据本协议向您主张权利。</p>
        </div>
        <h6>十、法律适用、管辖与其他</h6>
        <p>1.本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。 如发生本协议条款与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。</p>
        <p>2.本协议履行过程中，因您使用平台服务产生争议应由平台与您沟通并协商处理。协商不成时，双方均同意以平台管理者罗科仕科技（北京）股份有限公司注册地人民法院为管辖法院。
本协议最终解释权由哥伦布灵活用工商户平台所有。</p>
      </div>
    </el-dialog>
	</div>
</template>

<script>
  import collapse from './collapse.vue'
  import "@/shared/plugins/element"
	export default {
		components:{collapse},
		props:{
			//表单元素是并列同行还是独占一行
			inline:{
				type:Boolean,
				default:false
			},
			//表单标签宽度
			labelWidth:{
				type:String,
				default:'85px'
			},
			//表单标签位置
			labelPosition:{
				type:String,
				default:'right'
			},
      //类型
      typeList:{
        type:Object,
        default:()=>{}
      },
			//绑定的表单
			thirdStepForm:{
				type:Object,
				default:()=>{}
			},
      //指导价格
      guidePrice:{
        type:String,
        default:''
      },
      //显示指导价格提示语
      showPriceTip:{
        type:Boolean,
        default:false
      },
      //指导价格提示语内容
      priceTip:{
        type:String,
        default:''
      },
      //定期投放的时间选择器显示状态
      showTime:{
        type:Boolean,
        default:false
      },
      //校验规则
      rules:{
      	type:Object,
      	default:()=>{}
      },
      timeChoose:{
        type:Number,
        default:1
      }
		},
		data(){
			return {
        agreeMent:false,
        Props:{
          value:'id',
          label:'name',
          children:'children'
        }
			}
		},
    computed:{
    	dialogVisible: {
    	  get() {
    	    return this.timeChoose
    	  },
    	},
    	//确定按钮loading事件
    	timeTypes: {
    		get() {
    		  return this.timeChoose
    		},
    		set(val) {
    		  this.$emit('update:timeChoose', val)
    		}
    	}
    },
		methods:{
			// 表单验证
			async submitForm(prop) {
				try {
					return await this.$refs["form"].validate();
				} catch (error) {
					return error;
				}
			},
      //更改任务联系人
      changeContacts(val){
        this.$emit('changeContacts',val)
      },
      //更改任务单价，判断是否符合指导价
      changePrice(val){
        this.$emit('changePrice',val)
      },
      //更改数量；计算待支付金钱
      changeNumber(val){
        this.$emit('changeNumber',val)
      },
      //设置投放时长
      changeLaunch(val){
        this.$emit('changeLaunch',val)
      },
      //改变日期
      changeDate(val){
        this.$emit('update:timeChoose', val)
        this.$emit('changeDate',val)
      },
      //清除快捷日期
      clearQuick(val){
        this.$emit('clearQuick',val)
      },
      //查看协议
      watchAgrred(){
        this.agreeMent = true;
      },
      //选择省市区
      handleChange(val){
        let thsAreaCode = this.$refs['cascaderAddr'].getCheckedNodes();
        let obj = {
          area:thsAreaCode[0].pathLabels,
          val:val
        }
        this.$emit('cityChange',obj)
      },
		}
	}
</script>

<style scoped="scoped">
  p{ margin-bottom: 0 !important;font-size: 12px;}
  .number_input >>> input::-webkit-outer-spin-button,
  .number_input >>> input::-webkit-inner-spin-button { -webkit-appearance: none !important; }
  .number_input >>> input[type="number"]{ -moz-appearance: textfield !important; }
  .guide_price{ font-size: 12px; color:#1989FF; }
  .price_tip{ font-size: 12px; color:red;margin-left: 10px;}
  .advance_text{font-size: 14px;color: #666;}
  .mar_t_b{margin-top: 10px;margin-bottom: 15px;}
  .step_container >>> .el-form-item--mini .el-form-item__error{padding-top: 3px!important;}
  .agreement{color: #1989FF;cursor: pointer;}
  .more_explain{color: #1989FF;margin-left: 10px;cursor: pointer;}
  .explain_p{font-size: 14px;color: #333;line-height: 22px;}
  .text_indet{padding-left: 5px;}
  .agreement_box{padding: 0px 10px 50px;color: #666;font-size: 14px;height: 600px;overflow-y: auto;}
  .agreement_box h6{font-size: 16px;font-weight: 600;}
  .agreement_box p{margin-bottom: 5px;line-height: 22px;}
</style>
